module.exports = __webpack_public_path__ + "img/assettrackingttnloradeviceprofile.45d2f9de.png";